export default __webpack_public_path__ + "0578b80a29d980ebf628db50e9632ba8.png";